import { HostListener, Directive, ElementRef, Renderer2, Output, EventEmitter } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[ngBootstrapDropdown]',
  exportAs: 'ngDropDown',
})
export class BootstrapDropdownDirective {
  isOpen = false;

  @Output() clickOutside = new EventEmitter<boolean>();

  constructor(public el: ElementRef, private render: Renderer2) {}

  open(isToogle?: boolean): void {
    if (this.isOpen) {
      if (isToogle) {
        this.close();
      }
    } else {
      const parent = this.render.parentNode(this.el.nativeElement);
      if (parent) {
        this.addClass(parent);
      }

      this.addClass(this.el.nativeElement);
      this.isOpen = true;
    }
  }

  public close(): void {
    const parent = this.render.parentNode(this.el.nativeElement);
    if (parent) {
      this.removeClass(parent);
    }

    this.removeClass(this.el.nativeElement);

    this.isOpen = false;
  }

  @HostListener('document:click', ['$event.target'])
  public onClickOutClose(targetElement: any): void {
    this.clickOutside.emit(true);
    const parent = this.render.parentNode(this.el.nativeElement);
    const clickedInside = parent.contains(targetElement);
    if (!clickedInside) {
      this.close();
    }
  }

  private addClass(el: ElementRef): void {
    this.render.addClass(el, 'show');
  }

  private removeClass(el: ElementRef): void {
    this.render.removeClass(el, 'show');
  }
}
